import styled from 'styled-components'

export const BannerWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`

export const SlidesContainer = styled.div`
  display: flex;
  width: 100%;

  transform: translateX(
    ${({ current, dragOffset }) =>
      `calc(-${current * 100}% - ${dragOffset}px)`}
  );

  transition: ${({ isDragging }) =>
    isDragging ? 'none' : 'transform 0.75s cubic-bezier(0.22, 1, 0.36, 1)'};

  user-select: none;
  cursor: grab;

  touch-action: pan-y; /* 🔥 ESSENCIAL */

  &:active {
    cursor: grabbing;
  }
`
export const Slide = styled.div`
  width: 100%;
  flex-shrink: 0;
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;

    @media (max-width: 768px) {
      height: 250px;
    }
  }
`

export const Indicators = styled.div`
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
`

export const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background-color: ${({ active }) =>
    active ? '#348AC7' : '#ccc'};
  transition: background-color 0.3s;

  &:hover {
    background-color: #348AC7;
  }
`